<template>
    <section class="main">
        <div class="contact-header"></div>
        <ContactUs class="contact-us" />
        <ourMobileApplication class="our-mobile-contacts" />
    </section>
</template>

<script>
import ContactUs from "@/components/base/ContactUs.vue";

export default {
    name: "ContactsPage",
    components: {
        ContactUs,
    },
    inheritAttrs: false,
    computed: {
    },
    created() {
        this.jsonFile = {}
    }
}
</script>

<style scoped lang="scss">
.main {
    overflow: hidden;
}
.contact-header {
    min-height: 395px;
    background: url("~@/assets/contacts/contact-bg.jpg") no-repeat center/cover;
}
.contact-us {
    margin-top: -250px;
}
.our-mobile-contacts {
    margin-bottom: -14%;
}
</style>